/* Main modules */
import React from 'react'; // React
import ReactDOM from 'react-dom/client'; // ReactDOM
import App from './App'; // App
/* Third party modules */
import { AppProvider as PolarisAppProvider } from '@shopify/polaris'; // Shopify Polaris
import '@shopify/polaris/build/esm/styles.css'; // Polaris CSS
import { Provider as ReduxProvider } from 'react-redux'; // Redux Provider
import store from './store'; // Redux store
import ShopifyAppBridge from './components/Shopify/ShopifyAppBridge/ShopifyAppBridge'; // Shopify App Bridge
import { scan } from 'react-scan'
// 导入i18n配置
import './i18n';

// 声明 Willdesk 类型
declare global {
  interface Window {
    Willdesk: { boot: (settings: Record<string, unknown>) => void };
    WilldeskLoad: boolean;
  }
}

// 初始化 React Scan
scan({
  enabled: import.meta.env.PUBLIC_NODE_ENV === 'test', // 启用扫描功能
  log: true, // 在控制台输出日志
  showToolbar: false // 显示工具栏以便于操作
})

// 注册 Service Worker 缓存CSS
function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('Service Worker 注册成功，范围:', registration.scope);
        })
        .catch(error => {
          console.error('Service Worker 注册失败:', error);
        });
    });
  } else {
    console.warn('当前浏览器不支持 Service Worker');
  }
}

// 注册 Service Worker
registerServiceWorker();

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <ShopifyAppBridge>
      <PolarisAppProvider i18n={{}}>
        <ReduxProvider store={store}>
          <App />
        </ReduxProvider>
      </PolarisAppProvider>
    </ShopifyAppBridge>
  );
}
